import getPropFromModule from './getPropFromModule';

const getHasFetchedShop = state => getPropFromModule(state, 'hasFetched');

export default getHasFetchedShop;
